import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

type Props = {
  image: string;
  imageAlt: string;
  title: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  button?: {
    type: 'outlined' | 'contained' | 'text';
    text: string;
    onClick: () => void;
  };
  badge?: React.ReactNode;
};

export const NoItemsPlaceholder = ({ image, imageAlt, title, subTitle, button, badge }: Props) => (
  <Paper sx={{ py: 10, backgroundColor: 'grey.50' }}>
    <Box top={20} position="relative">
      {badge}
    </Box>
    <Stack gap={4} alignItems="center">
      <Box component="img" alt={imageAlt} src={image} />
      <Typography variant="h2" textAlign="center">
        {title}
      </Typography>
      <Typography variant="subtitle1" textAlign="center">
        {subTitle}
      </Typography>
      {button ? (
        <Button variant={button.type} onClick={button.onClick}>
          {button.text}
        </Button>
      ) : null}
    </Stack>
  </Paper>
);
